/**
 * @generated SignedSource<<7254aa5e25f921911d0d7368faaa5f14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemTilesCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_user">;
  readonly " $fragmentType": "ItemTilesCarousel_user";
};
export type ItemTilesCarousel_user$key = {
  readonly " $data"?: ItemTilesCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTilesCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTilesCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CarouselItemTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "25ba696afe5e7c7fe43919c06f941e21";

export default node;
